import { z } from "zod";
//#region src/my-channels.ts
/**
* Per-user release-channel switcher contract (#1075).
*
* A user entitled - via their group memberships - to more than one Customer
* Channel may self-select which one they consume. The selection is a
* server-persisted preference validated INSIDE the DP channel resolver against
* the tenant minimum-ring floor and the user's group-allowed candidate pool;
* it can only narrow/reorder within the authorized set, never elevate above
* the floor or onto a non-entitled channel.
*
* Response source of truth: DP `release.customer_channels` +
* `release.channel_assignments` + `release.user_channel_selection`.
*/
/**
* Body of `PUT /v1/release/my-channel`. `channelId=null` clears the selection
* (reverting to auto-resolution). Strict (#466): unknown keys rejected.
*/
const setMyChannelSchema = z.object({ channelId: z.string().uuid().nullable() }).strict();
//#endregion
export { setMyChannelSchema };

//# sourceMappingURL=my-channels.js.map